import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { catchError, map, Observable, of, take } from 'rxjs';

import { ProvisioningRepository } from '@efficiently/client-api-provisioning';
import { GraphQLClient } from '@efficiently/client-core-graphql';

import { CAPTURE_REGISTRATION } from '../queries/capture-registration';

@Injectable()
export class ProvisioningGqlRepository extends ProvisioningRepository {
	private readonly apollo = inject(Apollo);

	public override captureRegistration(): Observable<void> {
		return this.apollo
			.mutate({
				mutation: CAPTURE_REGISTRATION,
				context: { client: GraphQLClient.Identity },
			})
			.pipe(
				map(() => undefined),
				take(1),
				catchError(error => {
					console.error('Error capturing registration:', error);
					return of(null);
				}),
			);
	}
}
